// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-02-20 12:57:02 +0100 (Fri, 20 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160910 $
//  Purpose   : wrap thirdparty components for lazy loading
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { keys } from 'ldash';
import log from 'uix/logging';
// ---Globals
import { GetLoadable, GetLoadables, registerChunk, isUtilityChunkLoaded, getUtilityChunk, loadUtilityChunks, UtilityChunks } from './loader';
export { GetLoadable, GetLoadables, isUtilityChunkLoaded, getUtilityChunk, loadUtilityChunks, registerChunk } from './loader';
// only 'react-loadable' components
export { Document as PDFDocument, Page as PDFPage, Outline as PDFOutline } from './pdf';
// with single exposed default component
export { TeX } from './TeX';
export { Swiper } from './Swiper';
export { Markdown } from './markdown';
export { Highlight } from './prism';
// useChunk('TreeUtils') or via part/chunk requirement
export { ForceGraph2D, ForceGraph3D } from './rforce';
import { exportedThree } from './rforce';
registerChunk('ThreeUtils', exportedThree);
export { JSONTree, SearchableJSONTree } from './jsontree';
export { Draggable, Rnd } from './dnd';
export { ReactTable } from './rtable';
export { AutoSizer, Collection, List } from './rvirtualized';
export { ReflexContainer, ReflexSplitter, ReflexElement } from './rreflex';
// only useChunk imports
import { exportedRecharts } from './customRecharts';
registerChunk('Recharts', exportedRecharts);
import { exportedGraphology } from './graphology';
registerChunk('Graphology', exportedGraphology);
// direct importable lazy loaded react comp
export { SortableTree } from './sortableTree';
// useChunk('TreeUtils') or via part/chunk requirement
import { exportedTree } from './sortableTree';
registerChunk('TreeUtils', exportedTree);
export { CodeMirror, UnControlledCodeMirror, DiffView } from './codemirror';
import { exportedEditor } from './codemirror';
registerChunk('EditorUtils', exportedEditor);
//~ export {CodeMirror6} from './codemirror6'
export const CodeMirror6 = ({})=>null;
//~ export {CodeMirror6} from './codemirror6'
//~ import {exportedCodemirrorUtils} from './codemirror6'
//~ registerChunk('CodemirrorUtils', exportedCodemirrorUtils)
export { DmpViewBasic } from './dmp';
export const chunkNames = keys(UtilityChunks);
